import React from "react";
import { Search } from "lucide-react";

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const SearchInput: React.FC<SearchInputProps> = ({ className, ...props }) => {
  return (
    <div className="flex items-center border rounded-md p-2 text-sm text-gray-500 w-full max-w-60">
      <Search className="w-4 h-4 text-gray-400 mr-2" />
      <input
        type="text"
        className={`focus:outline-none w-full ${className}`}
        {...props}
      />
    </div>
  );
};

export default SearchInput;
